import { HTTPClient } from "@/common/HTTPClient";

export interface OperationMonitorRequestParams {
  search?: string;
  company_ids?: number[];
  status?: string;
  battery_status?: string; // critical|alarm|warning|normal|offline|no_data
  scope?: string; // "live" (default) | "all"
  page?: number;
  size?: number;
}

export class OperationMonitorClient {
  constructor(private httpClient: HTTPClient) {}

  public async getRvsSensors(params: OperationMonitorRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/api/v1/operation-monitor",
      method: "GET",
      params,
    });
    return data; // { items, total, page, size }
  }

  public async getRvsSensorSummary(params: OperationMonitorRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/api/v1/operation-monitor/summary",
      method: "GET",
      params,
    });
    return data; // { total, normal, warning, alarm, offline, no_data }
  }

  public async getRvsBatteryByCompany(params: OperationMonitorRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/api/v1/operation-monitor/battery-by-company",
      method: "GET",
      params,
    });
    return data; // { rows: [...], totals: {...} }
  }

  public async getRvsSensorsExport(params: OperationMonitorRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/api/v1/operation-monitor/export",
      method: "GET",
      params,
    });
    return data; // OperationMonitorSensor[]
  }
}
